import { getFocusableElements } from '../getFocusableElements';

import { HandleKeydown, IsOutsideClick, WatchKeyboardClose } from './events.types';
import { ARROW_DOWN, ARROW_DOWN_ATL, ARROW_UP, ARROW_UP_ATL, ENTERKEY, ENTERKEY_ATL, ESCAPE, ESCAPE_ATL, TAB } from './keyCodes';

export const handleKeydown: HandleKeydown = keys => callback => event => {
  const e = event as React.KeyboardEvent;
  if (keys.includes(e.key)) {
    // prevent default?
    callback(e);
  }
};

export const handleEscape = handleKeydown([ESCAPE, ESCAPE_ATL]);
export const handleTab = handleKeydown([TAB]);
export const handleArrowUp = handleKeydown([ARROW_UP, ARROW_UP_ATL]);
export const handleArrowDown = handleKeydown([ARROW_DOWN, ARROW_DOWN_ATL]);
export const handleEnter = handleKeydown([ENTERKEY, ENTERKEY_ATL]);

/** Returns a function that takes an Event object and determines if a keyboard event should close content. */
export const watchKeyboardClose: WatchKeyboardClose =
(contentAreaRef, closeFn) => {
  // holds trigger el in closure
  const triggerElement = document.activeElement as HTMLElement;

  // returns EventListener
  return e => {
    const event = e as React.KeyboardEvent;

    if (contentAreaRef && contentAreaRef.current !== null) {
      handleEscape(
        () => {
          if (triggerElement) { triggerElement.focus(); }
          closeFn();
        })(event);

      handleTab(
        () => {
          const focusableEls = getFocusableElements(contentAreaRef.current);
          const isTabbingOut = !event.shiftKey && document.activeElement === (focusableEls && focusableEls.lastElement);
          const triggerHasFocus = document.activeElement === triggerElement;
          const nothingFocusableInContent = focusableEls && !focusableEls.firstElement;

          if (isTabbingOut || (triggerHasFocus && nothingFocusableInContent)) {
            closeFn();
          }
        })(event);
    }
  };
};

/** Takes a element ref and an `Event` and determines if a click was made outside of it. */
export const isOutsideClick: IsOutsideClick =
  (contentAreaRef, event) => {
    const clickIsOutsideElem = contentAreaRef && contentAreaRef.current && !contentAreaRef.current.contains(event.target as Element);

    return clickIsOutsideElem || false;
  };
